module.exports = __webpack_public_path__ + "static/media/tmb_imgInfoM1.ec43769d.svg";